import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export interface RoleScreenYGPermissionParams {
    role_id: number;
    yeargroup_country_map_id?: number;
}

export const ListRoleScreenYGPermissionSlice = createSlice({
    name: "ListRoleScreenYGPermission",
    initialState: {} as IReduxState<any>,
    reducers: {
        getListRoleScreenYGPermission: (state, action: PayloadAction<RoleScreenYGPermissionParams>) => {
            state.isLoading = true;
        },
        successListRoleScreenYGPermission: (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        },
        failureListRoleScreenYGPermission: (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        },
        clearListRoleScreenYGPermission: (state) => {
            state.data = undefined;
        }
    },
});

export const {
    getListRoleScreenYGPermission,
    successListRoleScreenYGPermission,
    failureListRoleScreenYGPermission,
    clearListRoleScreenYGPermission
} = ListRoleScreenYGPermissionSlice.actions;

export default ListRoleScreenYGPermissionSlice.reducer;
